var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"slots"},_vm._l((_vm.day.slots),function(slot,i){return _c('leave-slot',_vm._b({key:i,on:{"bid":function($event){return _vm.$emit('bid', $event)}}},'leave-slot',{
                    selectable: _vm.isSelectable,
                    allowed: _vm.isAllowed,
                    leaveslot: slot,
                    day: _vm.day,
                    },false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }